import styled from 'styled-components'

export const Description = styled.div`
  margin-bottom: 8px;
`
export const Question = styled.div`
  margin-bottom: 8px;
`
